import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

import './drop-file-input.css';

import { ImageConfig } from '../../config/ImageConfig';
import uploadImg from '../../assets/cloud-upload-regular-240.png';

const DropFileInput = (props) => {
    const wrapperRef = useRef(null);
    const [isProcessing, setIsProcessing] = React.useState(false);

    const [fileList, setFileList] = useState([]);

    const onDragEnter = () => wrapperRef.current.classList.add('dragover');

    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        const newFile = e.target.files[0];
        console.log(newFile)
        if (newFile && fileList.length === 0) {
            const updatedList = [...fileList, newFile];
            setFileList(updatedList);
            props.onFileChange(updatedList);
        }
    };

    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
        props.onFileChange(updatedList);
    };

    const submitXLSX = () => {
        setIsProcessing(true)
        console.log(fileList[0])
        console.log("Started uploading xlsx")
        const formData = new FormData();
        formData.append("file", fileList[0]);

        let data = axios.post('/api/xls', formData, {
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            }
        })
            .then(response => {
                console.log(response.data)
                showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
                if ((response.data && (response.data.missing.length != 0))) {
                    showErrorToast((response.data && response.data.missing) ? "Failed to upload the following row index:" + response.data.missing.join(',') : "", 10000)
                }
                // console.log(response.data.missing)
                setIsProcessing(false)

            })
            .then(() => {
                setFileList([])
            })
            .catch(error => {
                // Handle error
                showErrorToast("Error in Uploading xlsx");
                setIsProcessing(false)

                console.error(error);
            });
        console.log("Ending uploading xlsx")

    }

    return (
        <div>
            <div
                ref={wrapperRef}
                className="drop-file-input"
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <div className="drop-file-input__label">
                    <img src={uploadImg} alt="" />
                    <p>Drag & Drop your file here</p>
                </div>
                <input type="file" accept=".xlsx, .csv" value="" onChange={onFileDrop} />
            </div>
            {fileList.length > 0 && (
                <div className="drop-file-preview">
                    <p className="drop-file-preview__title">Ready to upload</p>
                    {fileList.map((item, index) => (
                        <div key={index} className="drop-file-preview__item">
                            <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} height="50%" alt="img_not_found" />
                            <div className="drop-file-preview__item_ _info">
                                <>{item.name}</><br/>
                                <>{item.size}B</>
                            </div>
                            <span className="drop-file-preview__item__del h1" onClick={() => fileRemove(item)}>
                                <CloseIcon />
                            </span>
                        </div>

                    ))}
                </div>
            )}
            {
                fileList.length > 0 && (
                    <div className='mx-auto d-flex justify-content-center align-items-center'>

                        <button
                            type="button"
                            onClick={submitXLSX}
                            className="btn btn-info btn-md mx-auto px-5"
                            disabled={isProcessing}
                        >
                            {isProcessing ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2 mx-2 my-2" role="status" aria-hidden="true" />
                                    <span>Processing...</span>
                                </>
                            ) : (
                                'Upload Bulk File'
                            )}
                        </button>
                    </div>

                )
            }
        </div>
    );
};

DropFileInput.propTypes = {
    onFileChange: PropTypes.func,
};

export default DropFileInput;
